var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h496.06v372.05H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2902)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M.013 0h499.55v248.1H.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.013 0l-.02 18.621 119.21 61.253 44.86 1.3L.012 0z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.054 0l144.53 75.491V.001H51.064z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M214.86 0v96.372H.02v55.07h214.84v96.372h66.106v-96.372h214.84v-55.07h-214.84V0H214.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.24 0v71.132L441.63.552 300.24 0z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71 78.887l39.76-.32L498.95.551l-40.99.668-153.25 77.668z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.013 167.5v52.775l99.16-52.22-99.16-.56z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85 169.68l-41.336-.321 155.82 77.58-1.025-17.749-113.46-59.51zM38.73 248.25l146.11-76.71-38.38.26L.01 248.14",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.9 21.795l-118 58.515 116.43.436v87.194h-99.159l98.242 53.23 1.442 27.08-52.474-.627-143.62-70.505v71.132h-104.67v-71.132l-134.72 70.94-60.844.192v247.81h991.59V.43L498.947 0M.537 27.971L.014 79.438l104.39 1.308L.544 27.971z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    fill: "#ffd900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.06 0h496.06v496.06H496.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 248.03h523.49v248.03H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.9 125.29c0 23.619-19.148 42.767-42.768 42.767-23.619 0-42.767-19.147-42.767-42.767s19.147-42.767 42.767-42.767c23.62 0 42.767 19.147 42.767 42.767z",
    fill: "#000067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff40d",
    d: "M240.189 114.32l8.225-24.592 8.224 24.591 26.686-.018-21.603 15.175 8.266 24.58-21.577-15.211-21.577 15.207 8.27-24.576-21.6-15.182zM388.737 118.346l4.076-11.512 4.076 11.512 13.226-.008-10.707 7.104 4.097 11.508-10.694-7.122-10.693 7.12 4.098-11.506-10.704-7.107zM244.057 203.886l4.076-11.512 4.076 11.512 13.226-.008-10.707 7.104 4.097 11.508-10.694-7.122-10.693 7.12 4.098-11.506-10.704-7.107zM244.057 36.836l4.076-11.512 4.076 11.512 13.226-.008-10.707 7.104 4.097 11.508-10.694-7.122-10.693 7.12 4.098-11.506-10.704-7.107zM98.93 118.346l4.076-11.512 4.076 11.512 13.225-.008-10.706 7.104 4.096 11.508-10.693-7.122-10.694 7.12 4.099-11.506-10.705-7.107z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.5b5a4fb3d842c7a0bd1d405bdec857c5.svg";
export { ForwardRef as ReactComponent };